export const translations = {
  de: {
    finePrint: `
      * Die Tarife PERSONAL, STANDARD und BUSINESS verstehen
      sich inklusive großzügig bemessenem, monatlichen
      Fair-Use-Datenvolumen für Traffic, Upload und Encoding,
      das in 99% aller Fälle mehr als ausreicht. Sollte sich
      dein Pageflow plötzlich zur weltweiten Erfolgsstory
      entwickeln, keine Sorge: Du wirst rechtzeitig per Mail
      informiert und kannst deinen Tarif entsprechend anpassen.`,
    pageflowNext: {
      title: 'Pageflow Next',
      description: 'Storytelling neu gedacht: Erstelle im Handumdrehen beeindruckenden Web Content für alle Plattformen'
    },
    pageflowClassic: {
      title: 'Pageflow Classic',
      description: 'Der Klassiker seit 2014: Seiten-basierte Beiträge mit interaktiven Storylines'
    },
    users: {
      title: 'Benutzer',
      description: 'Anzahl von Nutzerkonten mit eigenem Login, Rollen und Rechten'
    },
    publishedEntries: {
      title: 'Veröffentlichte Beiträge',
      description: 'Anzahl der Beiträge die gleichzeitig veröffentlicht sein können'
    },
    sites: {
      title: 'Sites',
      description: 'Anzahl der Sites mit eigener Domain und individuellem Branding'
    },
    additionalSites: {
      title: 'Weitere Sites zubuchbar',
      description: 'Preise auf Anfrage'
    },
    hasTicketSupport: {
      title: 'E-Mail- / Ticket-Support',
      description: 'Individueller Support per Ticketsystem, 24-Stunden-Garantie an Werktagen'
    },
    hasExtendedSupport: {
      title: 'Erweiterter Support',
      description: 'Individueller Priority-Support mit direktem Draht zum Entwickler-Team'
    },
    hasStylingOptions: {
      title: 'Eigenes Logo / Farbschema',
      description: 'Verwendung von Logo und CI-Farben für die Navigationselemente'
    },
    hasCustomFonts: {
      title: 'Eigene Schrift',
      description: 'Implementierung eigener Fonts nach Zulieferung der Webfont-Pakete'
    },
    hasWhiteLabel: {
      title: 'White Label',
      description: 'Ausblenden des Pageflow Brandings im Footer'
    },
    hasCustomTheme: {
      title: 'Customized Theme',
      description: 'Maßgeschneiderte Anpassungen nach CI Vorgabe'
    },
    hasCustomDomain: {
      title: 'Eigene Domain',
      description: 'Nutzung einer eigenen Domain für deine Stories'
    },
    hasCustomCertificate: {
      title: 'Eigenes SSL-Zertifikat',
      description: 'Individuelles SSL-Zertifikat anstelle des automatisch generierten Zertifikats verwenden'
    },
    hasSso: {
      title: 'SSO (Single Sign-On)',
      description: 'Externe Benutzerverwaltung für eine vereinfachte Authentifizierung von Redakteuren'
    },
    hasGoogleAnalytics: {
      title: 'Google Analytics',
      description: 'Tracking von Impressionen, Sitzungen & Verweildauer pro Beitrag'
    },
    hasPlausibleAnalytics: {
      title: 'Plausible Analytics',
      description: 'Datenschutzfreundliche Alternative zu Google Analytics - kostenlos im Tarif enthalten für Websites mit weniger als 50k Seitenaufrufen pro Monat'
    },
    hasCustomAnalytics: {
      title: 'Weitere Tracking Integrationen',
      description: 'Integration von Analytics-Diensten wie Matomo, etracker, Piano Analytics uvm.'
    },
    hasCustomConsent: {
      title: 'Consent Management Integrationen',
      description: 'Anbindung von Consent Management Plattformen wie Usercentrics oder Sourcepoint'
    },
    hasIframeEmbedContentElement: {
      title: 'iframe Embed Element',
      description: 'Interaktive Inhalte von Drittanbietern und Microsites in Next Beiträge integrieren'
    },
    cdnTraffic: {
      title: 'CDN Bandwidth',
      description: 'Bestmögliche Ausspielung über ein globales CDN und leistungsstarke Server'
    },
    mediaEncoding: {
      title: 'Media Encoding',
      description: 'Wandlung der Eingabe-Dateien in unterschiedliche Ausgabeformate'
    },
    unlimited: 'Unbegrenzt',
    fairUse: 'Fair use*',
    yes: 'Ja',
    enterpriseHeader: 'Enterprise Tarife',
    enterpriseButton: 'Schreib uns',
    enterpriseText: `
      Du benötigst mehr User und weitere Sites? Oder maßgeschneiderte Funktionen,
      wie App-Integrationen, individuelle Content-Elemente oder eine eigene Navigation?
      Gemeinsam finden wir eine auf dich zugeschnittene Lösung.
    `,
    newTicketUrl: 'https://pageflow.freshdesk.com/de/support/tickets/new'
  },
  en: {
    finePrint: `
       * Our PERSONAL, STANDARD and BUSINESS plans include a monthly
       fair-use data volume for traffic, upload and encoding, which
       is more than sufficient in 99% of cases. If your Pageflow
       suddenly turns into a worldwide success story, don't worry:
       you'll be informed by email in good time and can adjust your
       plan accordingly.`,
    pageflowNext: {
      title: 'Pageflow Next',
      description: 'Storytelling reimagined: Quickly create compelling web content for all platforms'
    },
    pageflowClassic: {
      title: 'Pageflow Classic',
      description: 'The classic since 2014: page-based stories with interactive branching'
    },
    publishedEntries: {
      title: 'Published stories',
      description: 'Number of stories published at the same time'
    },
    users: {
      title: 'Users',
      description: 'Number of user accounts with own login, roles and rights'
    },
    sites: {
      title: 'Sites',
      description: 'Number of sites with own domain and individual branding'
    },
    additionalSites: {
      title: 'Additional sites available',
      description: 'Prices on request'
    },
    hasTicketSupport: {
      title: 'E-Mail- / Ticket-Support',
      description: 'Individual support via ticket system, 24-hour guarantee on working days'
    },
    hasExtendedSupport: {
      title: 'Extended Support',
      description: 'Individual priority support with a direct line to the development team'
    },
    hasStylingOptions: {
      title: 'Own logo / color scheme',
      description: 'Use of own logo and CI colors for navigation elements'
    },
    hasCustomFonts: {
      title: 'Own font',
      description: 'Implementation of own fonts after delivery of webfont packages'
    },
    hasWhiteLabel: {
      title: 'White Label',
      description: 'Hide the Pageflow branding in footer'
    },
    hasCustomTheme: {
      title: 'Customized Theme',
      description: 'Customized adaptation according to CI specifications'
    },
    hasCustomDomain: {
      title: 'Own domain',
      description: 'Usage of own domain for published stories'
    },
    hasCustomCertificate: {
      title: 'Custom SSL certificte',
      description: 'Use a custom SSL certificate instead of the automatically generated certificate'
    },
    hasSso: {
      title: 'SSO (Single Sign-On)',
      description: 'Centralized external user management for streamlined editor authentication'
    },
    hasGoogleAnalytics: {
      title: 'Google Analytics',
      description: 'Tracking of impressions, sessions & dwell time per story'
    },
    hasPlausibleAnalytics: {
      title: 'Plausible Analytics',
      description: 'Privacy-friendly Google Analytics alternative - included free of charge for sites with less than 50k page views per month.'
    },
    hasCustomAnalytics: {
      title: 'Advanced Tracking Integrations',
      description: 'Integration of analytics services such as Matomo, etracker, Piano Analytics and many more'
    },
    hasCustomConsent: {
      title: 'Consent Management Integrations',
      description: 'Integration of consent managment platforms such as Usercentrics or Sourcepoint'
    },
    hasIframeEmbedContentElement: {
      title: 'iframe Embed Element',
      description: 'Integrate interactive content from third-party providers and microsites into Next stories'
    },
    cdnTraffic: {
      title: 'CDN Bandwidth',
      description: 'Best possible playout via a global CDN and high-performance servers'
    },
    mediaEncoding: {
      title: 'Media Encoding',
      description: 'Conversion of uploaded media files into different output formats'
    },
    unlimited: 'Unlimited',
    fairUse: 'Fair use*',
    yes: 'Yes',
    enterpriseHeader: 'Enterprise Plans',
    enterpriseButton: 'Contact us',
    enterpriseText: `
      Need more users and more sites? Customized functions, such as app integrations,
      individual content elements or your own navigation? Let’s find solutions
      tailored to your needs.
    `,
    newTicketUrl: 'https://pageflow.freshdesk.com/en/support/tickets/new'
  }
};
